export default {"src":"/_next/static/media/GloDollarLogo.eb34a2d3.svg","height":1280,"width":1280,"blurWidth":0,"blurHeight":0};